export default "__VITE_ASSET__7327915f__"